import Logger from '../lib/logger';

export default class ImageLoader {

  constructor() {
    this.NAME = `ImageLoader`;
    Logger.info(`${this.NAME} > constructor`);
  }

  loadImage(src, img) {
    return new Promise((resolve) => {
      if (!img) img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = src;
    })
  }

  loadArray(sources) {
    Logger.info(`${this.NAME} > loadArray`);
    const promises = [];
    sources.forEach(src => {
      promises.push(this.loadImage(src));
    });
    return Promise.all(promises);
  }

  async loadDictionary(dict) {
    Logger.info(`${this.NAME} > loadDictionary`);
    const promises = [];
    const obj = {};
    Object.keys(dict).forEach(key => {
      const img = new Image();
      obj[key] = img;
      promises.push(this.loadImage(dict[key], img));
    })
    await Promise.all(promises);
    return obj;
  }
}
